import { render, staticRenderFns } from "./NewYearConfig.vue?vue&type=template&id=c781c332&scoped=true&"
import script from "./NewYearConfig.vue?vue&type=script&lang=js&"
export * from "./NewYearConfig.vue?vue&type=script&lang=js&"
import style0 from "./NewYearConfig.vue?vue&type=style&index=0&id=c781c332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c781c332",
  null
  
)

export default component.exports